import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {campaignsType, getCampaigns} from '../../../apis/campaign/getCampaigns'

const useQueryCampaigns = (status: campaignsType) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.campaign.getCampaigns(),
        queryFn: async () => {
            const {data, pageInfo} = await getCampaigns(status)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryCampaigns
